import { StyleSheet, View, type ViewProps } from "react-native";

import { spacing } from "~/styles/theme";
import type { Space } from "./types";

export function Grid({
  gap = "md",
  style,
  ...props
}: ViewProps & { gap?: Space }) {
  return <View style={[stylesheet.grid, gapStyles[gap], style]} {...props} />;
}

export function GridItem({
  minWidth = 160,
  style,
  ...props
}: ViewProps & { minWidth?: number }) {
  return (
    <View
      style={[stylesheet.item, { minWidth, flexBasis: minWidth }, style]}
      {...props}
    />
  );
}

const stylesheet = StyleSheet.create({
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  item: { flexGrow: 1, flexShrink: 1 },
  gapNone: { gap: 0 },
  gapXs: { gap: spacing.xs },
  gapSm: { gap: spacing.s },
  gapMd: { gap: spacing.m },
  gapLg: { gap: spacing.l },
  gapXl: { gap: spacing.xl },
  gapXxl: { gap: spacing.xxl },
});

const gapStyles = {
  none: stylesheet.gapNone,
  xs: stylesheet.gapXs,
  sm: stylesheet.gapSm,
  md: stylesheet.gapMd,
  lg: stylesheet.gapLg,
  xl: stylesheet.gapXl,
  xxl: stylesheet.gapXxl,
};
